import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/preguntasConfirmacion/preguntasConfirmacion.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const PreguntaConfirmacionViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedPregunta,
    selectedPreguntaLoading,
    selectedPreguntaError,
  } = useSelector((state) => state.preguntasConfirmacion);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de la pregunta"
      size="lg"
    >
      {selectedPreguntaLoading && (
        <Loader center text="Cargando información de la pregunta..." delay={150} type="dots" />
      )}

      {selectedPreguntaError && (
        <p className="text-danger">{selectedPreguntaError}</p>
      )}

      {!selectedPreguntaLoading && selectedPregunta && (
        <div className="row g-4">
          <div className="col-12">
            <Field
              icon="mdi:help-circle-outline"
              label="Pregunta"
              value={selectedPregunta.pregunta}
            />
          </div>

          <div className="col-12">
            <Field
              icon="mdi:toggle-switch-outline"
              label="Estado"
              value={selectedPregunta.is_active ? "Activa" : "Inactiva"}
            />
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedPregunta.created_at}
              updatedAt={selectedPregunta.updated_at}
              createdBy={selectedPregunta.created_by}
              updatedBy={selectedPregunta.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PreguntaConfirmacionViewModal;
